import { axiosInstance } from './axios.js';
import Cookies from "js-cookie"
import port from "../helper.js";
import axios from 'axios';


let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // If unauthorized and not already retrying
        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return axiosInstance(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                console.log("hello1")
                const token = Cookies.get("refreshToken")

                const response = await axios.post(`${port}/api/v1/users/refresh-token`, {},
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const newAccessToken = response.data.data.accessToken;
                // await delay(100);
                Cookies.set("accessToken", response.data.data.accessToken, { expires: 15 / 1440 })
                // await delay(100);
                Cookies.set("refreshToken", response.data.data.refreshToken, { expires: 7 })

                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

                processQueue(null, newAccessToken);

                return axiosInstance(originalRequest);
            } catch (err) {
                processQueue(err, null);
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);
